var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowToRight1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 38,
    viewBox: "0 0 50 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 12,
    cy: 18.5,
    r: 12,
    fill: "#775D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7488 18.3913L41.1127 9.75501C40.8025 9.39276 40.2573 9.35053 39.895 9.66083C39.5327 9.97106 39.4905 10.5163 39.8008 10.8785C39.8298 10.9123 39.8612 10.9438 39.895 10.9727L47.0544 18.1408H12.8636C12.3867 18.1408 12 18.5274 12 19.0044C12 19.4814 12.3867 19.868 12.8636 19.868H47.0544L39.895 27.0274C39.5327 27.3376 39.4905 27.8829 39.8008 28.2451C40.1111 28.6074 40.6562 28.6496 41.0185 28.3393C41.0523 28.3103 41.0838 28.2789 41.1127 28.2451L49.7489 19.6089C50.0837 19.2721 50.0837 18.7281 49.7488 18.3913Z",
    fill: "#775D00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToRight1);
export default __webpack_public_path__ + "static/media/ArrowToRight1.9ce93892ca699a2dd503a410013d2fe4.svg";
export { ForwardRef as ReactComponent };